import log from "cslog";
import { parseStyle, decodeStyle, mobile, tablet } from "../../../juntion";
// import SlateViewer from "../../../../widgets/slateeditor/SlateViewer";
import { SlateViewer } from "../../../juntion";
import { getContent, getHTMLContent } from "../../../junctionAbs";

function HtmlText({ id, db, gs, device, dydb, ctx }) {
	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	const tabletStyle = tablet(device) ? ps.tablet : {};
	const mobileStyle = mobile(device) ? ps.mobile : {};

	let input = ps.input;
	const html = getHTMLContent(dydb, input?.html);


	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	let styles = decodeStyle(ps.style, gs);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					columnWidth: "auto",
					columnCount: input.columnCount,
					...decodeStyle(ps.fixStyle, gs),
					...decodeStyle(ps.style, gs),
					// "&:hover": decodeStyle(ps.hover, gs),
					textAlign: input.textAlign,
				}}
			>
				{/* <h3>HTML Text Coming soon..</h3> */}
				<SlateViewer id={id}
					// input={input} 
					input={{
						...input,
						html: html
					}}
					styles={styles}
					dydb={dydb}
				/>
			</div>
		</div>
	);
}

export default HtmlText;
